module.exports = __webpack_public_path__ + "img/induction-banner.41bda7ee.jpg";